import React from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';

export const AssignedIcon = () => {
  return (
    <Icon
      id="person_check_assigned"
      width="16"
      height="20"
      className="align-middle text-blue-700"
      accessibility={{
        ariaLabel: 'Assigned',
      }}
    />
  );
};
